import React from "react";

export const FooterDivider = () => {
    return <> / </>;
};
